import { Alert, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BarGraph from "../../../../components/OrgAdminGraph/BarGraph";
import LineGraph from "../../../../components/OrgAdminGraph/LineGraph";
import SpiderChart from "../../../../components/OrgAdminGraph/SpiderChart";
import StackedColumn from "../../../../components/OrgAdminGraph/StackedColumn";
import TableTitleBar from "../../../../components/TableTitleBar/TableTitleBar";
import Domain from "../../../../models/Domain";
import Survey from "../../../../models/Survey";
import organizationViewSurveyTabStyles from "./OrganizationViewSurveyTab.module.scss";

import "./OrganizationViewSurveyTab.scss";

class OrganizationViewSurveyTabProps {
  /**
   * @callback onYearsChangeCallback;
   */
  /**
   * @type {onYearsChangeCallback}
   */
  onYearsChange;

  /**
   * @callback onSurveyChangeCallback;
   */
  /**
   * @type {onSurveyChangeCallback}
   */
  onSurveyChange;

  /**
   * @type {string[]}
   */
  years;

  /**
   * @type {Survey[]}
   */
  surveys;

  /**
   * @type {boolean}
   */
  isYearsLoading;

  /**
   * @type {boolean}
   */
  isSurveysLoading;

  /**
   * @type {Domain[]}
   */
  chartData;

  /**
   * @type {string}
   */
  defaultYear;

  /**
   * @type {string}
   */
  defaultSurvey;

  /**
   * @type {boolean}
   */
  isChartLoading;
}

/**
 *
 * @param {OrganizationViewSurveyTabProps} props
 * @returns {JSX.Element}
 */
export default function OrganizationViewSurveyTab(props) {
  return (
    <div
      className={`${organizationViewSurveyTabStyles.container1} OrganizationViewSurveyTab`}
    >
      <TableTitleBar
        title={
          props.defaultYear +
          " - " +
          ((props.surveys &&
            (props.surveys || []).find((s) => s.id === props.defaultSurvey)
              ?.name) ||
            props.defaultSurvey)
        }
      ></TableTitleBar>
      <div className={organizationViewSurveyTabStyles.chartContainer}>
        {!props.isChartLoading ? (
          <div className={organizationViewSurveyTabStyles.chats}>
            <div className="progress-graph">
              {props.chartData[3]?.data?.data &&
              Array.isArray(props.chartData[3]?.data?.data) &&
              props.chartData[3]?.data?.data.length > 0 ? (
                <LineGraph graphData={props.chartData[3]?.data?.data ?? []} />
              ) : (
                <Alert
                  message='No data to show "Progress Graph."'
                  type="info"
                />
              )}
            </div>
            {Array.isArray(props.years) && props.years.length > 0 && (
              <div
                className={
                  organizationViewSurveyTabStyles.surveyYearDropdownContainer
                }
              >
                <div
                  className={
                    organizationViewSurveyTabStyles.titleSelectContainer
                  }
                >
                  <Select
                    onChange={props.onYearsChange}
                    bordered={false}
                    className={organizationViewSurveyTabStyles.select}
                    value={props.defaultYear}
                    style={{ width: 155 }}
                    loading={props.isYearsLoading}
                  >
                    {props.years?.map((year, index) => (
                      <Select.Option key={index} value={year}>
                        {year}
                      </Select.Option>
                    ))}
                  </Select>

                  <Select
                    bordered={false}
                    onChange={props.onSurveyChange}
                    className={organizationViewSurveyTabStyles.select}
                    value={props.defaultSurvey}
                    style={{ width: 205 }}
                    loading={props.isSurveysLoading}
                  >
                    {props.surveys.map((survey) => (
                      <Select.Option key={survey.id} value={survey.id}>
                        {survey.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
            )}

            {Array.isArray(props.chartData[0]?.data?.data) &&
            props.chartData[0]?.data?.data.length > 0 ? (
              <div className="super-admin-spider-chart">
                <SpiderChart
                  domains={props.chartData[0]?.data?.data ?? []}
                  height={"70%"}
                />
              </div>
            ) : (
              <Alert
                message='No data to show "Completed %" graph.'
                type="info"
              />
            )}

            {(props.chartData[0]?.data?.data ?? []).length > 0 &&
            (props.chartData[2]?.data.data[0]?.mil_data ?? []).length > 0 &&
            (props.chartData[1]?.data?.data ?? []).length > 0 ? (
              <BarGraph
                domains={props.chartData[0]?.data?.data ?? []}
                graphData={props.chartData[2]?.data.data[0]?.mil_data ?? []}
                masterData={props.chartData[1]?.data?.data ?? []}
              />
            ) : (
              <Alert
                message='No data to show "Summary of CRR Results" graph.'
                type="info"
              />
            )}

            {(props.chartData[0]?.data?.data ?? []).length > 0 ? (
              <StackedColumn
                domains={props.chartData[0]?.data?.data ?? []}
                selectedSurvey={props.defaultSurvey}
                isAdmin
              />
            ) : (
              <Alert
                message='No data to show "Performance Summary" graph.'
                type="info"
              />
            )}
          </div>
        ) : (
          <Spin />
        )}
      </div>
    </div>
  );
}
